// src/lib/portalPageTitleStyle.js — the shared page-title treatment: large,
// small caps (capital first letters, small caps for the rest; was uppercase
// until 2026-10-20), letter-spaced, aligned per PORTAL_TITLE_ALIGN. Originally MandateHeader's
// mandate-name style; PortalMandates' own page title was matched to it, and
// this is that same style factored out so every top-level portal page
// (Mandates, Contacts, Settings, and any future one) uses one
// definition instead of four copies drifting apart.
// Experiment 2026-10-08: titles moved back to the left. Flip this one value
// to 'right' to restore the right-justified headers everywhere.
export const PORTAL_TITLE_ALIGN = 'left'

// 2026-10-23: standardized to the CRM page title (.page-header-text h1:
// 30px bold, normal capitals). The small-caps version, kept here in case a
// variant comes back:
//   fontVariant: 'small-caps', fontSize: 'clamp(28px, 4vw, 40px)',
//   letterSpacing: '0.01em', lineHeight: 1.1
export const PORTAL_PAGE_TITLE_STYLE = {
  textAlign: PORTAL_TITLE_ALIGN,
  fontSize: 30,
  fontWeight: 700,
  lineHeight: 1.2,
  color: 'var(--text-primary)',
}
